'use client';

import { useEffect, useState } from 'react';
import { Group, Text } from '@mantine/core';
import classes from './offline_banner.module.css';
import { checkNetworkConnection } from '@/utils/network';

export default function OfflineBanner() {
  const [isOffline, setIsOffline] = useState(false);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    // Function to check connection and update state
    const checkConnection = async () => {
      const isOnline = await checkNetworkConnection();
      setIsOffline(!isOnline);
    };

    // Check immediately on mount
    checkConnection();

    // Set up periodic checks (every 30 seconds)
    const intervalId = setInterval(checkConnection, 30000);

    // Also check when online/offline events fire, but with a small delay
    const handleStatusChange = () => {
      // Clear any pending timeout
      if (timeoutId) clearTimeout(timeoutId);
      
      // Wait a short moment before checking (helps prevent flickering)
      timeoutId = setTimeout(checkConnection, 1000);
    };

    window.addEventListener('online', handleStatusChange);
    window.addEventListener('offline', handleStatusChange);

    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
      window.removeEventListener('online', handleStatusChange);
      window.removeEventListener('offline', handleStatusChange);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <Group className={classes.offlineBanner}>
      <Group gap="xs" mx="auto">
        <Text size="sm" fw={500}>
          No Internet Connection
        </Text>
      </Group>
    </Group>
  );
}